"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSharedInfo = exports.setSharedInfo = void 0;
var utils_1 = require("./utils");
Object.defineProperty(exports, "setSharedInfo", { enumerable: true, get: function () { return utils_1.setSharedInfo; } });
Object.defineProperty(exports, "getSharedInfo", { enumerable: true, get: function () { return utils_1.getSharedInfo; } });
//# sourceMappingURL=index.js.map